(
  /**
   * @param {JQueryStatic} $
   */
    function ($) {
      let step = 1;

    // @ts-ignore
    window.bloomableReminders = window.bloomableReminders || {
      showNewReminder: function () {
        const popup = $("#bloomable-reminders-new-popup");

        popup.show();

        popup.on("click", "#bloomable-reminders-new-close-button", function () {
          var form = popup.find("form");

          form.find("[name='name']").val("");
          form.find("[name='occasion']").val("");
          form.find("[name='day']").val("");
          form.find("[name='month']").val("");
          form.find("[name='christmas']").prop("checked", false);
          form.find("[name='fathersDay']").prop("checked", false);
          form.find("[name='mothersDay']").prop("checked", false);
          form.find("[name='valentinesDay']").prop("checked", false);
          popup.hide();
        });

        popup.on("click", 'a[href="#back"]', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var form = popup.find("form");

          form.find("[name='name']").val("");
          form.find("[name='occasion']").val("");
          form.find("[name='day']").val("");
          form.find("[name='month']").val("");
          form.find("[name='christmas']").prop("checked", false);
          form.find("[name='fathersDay']").prop("checked", false);
          form.find("[name='mothersDay']").prop("checked", false);
          form.find("[name='valentinesDay']").prop("checked", false);
          popup.hide();
        });

        popup.on("click", 'button[type="reset"]', function () {
          var form = popup.find("form");

          form.find("[name='name']").val("");
          form.find("[name='occasion']").val("");
          form.find("[name='day']").val("");
          form.find("[name='month']").val("");
          form.find("[name='christmas']").prop("checked", false);
          form.find("[name='fathersDay']").prop("checked", false);
          form.find("[name='mothersDay']").prop("checked", false);
          form.find("[name='valentinesDay']").prop("checked", false);
          popup.hide();
        });

        popup.find("form").on("submit", function (e) {
          e.preventDefault();

          var form = $(this);
          var actionUrl = form.attr("action");

          $.ajax({
            type: "POST",
            url: actionUrl,
            data: form.serialize(),
            success: function () {
              form.find("[name='name']").val("");
              form.find("[name='occasion']").val("");
              form.find("[name='day']").val("");
              form.find("[name='month']").val("");
              form.find("[name='christmas']").prop("checked", false);
              form.find("[name='fathersDay']").prop("checked", false);
              form.find("[name='mothersDay']").prop("checked", false);
              form.find("[name='valentinesDay']").prop("checked", false);

              popup.hide();
            },
          });
        });
      },
      syncLocalReminders() {
        /**
         * @type {string | null} reminders
         */
        let reminders = localStorage.getItem("reminders");

        if (reminders) {
          $.ajax({
            url: "/apps/reminders/sync",
            type: "post",
            data: reminders,
            headers: {
              "Content-Type": "application/json",
            },
            dataType: "json",
            success: function (data) {
              if (data.code) {
                $("#bloomable-reminders-code").text(data.code);

                // @ts-ignore
                window.bloomableReminders.complete();
              }
              localStorage.removeItem("reminders");
            },
          });
        }
      },
      /**
       * @param {JQuery<HTMLFormElement>} form
       * @param {boolean} loggedInUser
       */
      saveWizardReminder: function (form, loggedInUser) {
        if (loggedInUser) {
          var actionUrl = form.attr("action");

          $.ajax({
            type: "POST",
            url: actionUrl,
            data: form.serialize(),
            success: function (data) {
              if (data.code) {
                $("#bloomable-reminders-code").text(data.code);
              }

              form.find("[name='name']").val("");
              form.find("[name='occasion']").val("");
              form.find("[name='day']").val("");
              form.find("[name='month']").val("");
              form.find("[name='christmas']").prop("checked", false);
              form.find("[name='fathersDay']").prop("checked", false);
              form.find("[name='mothersDay']").prop("checked", false);
              form.find("[name='valentinesDay']").prop("checked", false);

              if (step < 3) {
                // @ts-ignore
                window.bloomableReminders.nextStep();
              } else {
                $("#bloomable-reminders-wizard-popup").hide();
                // @ts-ignore
                window.bloomableReminders.complete();
              }
            },
          });
        } else {
          /**
           * @type {Array} reminders
           */
          let reminders = JSON.parse(localStorage.getItem("reminders") ?? "[]");

          let f = form.get(0);

          if (f) {
            const formData = new FormData(f);

            reminders.push({
              name: formData.get("name"),
              occasion: formData.get("occasion"),
              day: formData.get("day"),
              month: formData.get("month"),
              christmas: formData.get("christmas"),
              fathersDay: formData.get("fathersDay"),
              mothersDay: formData.get("mothersDay"),
              valentinesDay: formData.get("valentinesDay"),
            });

            form.find("[name='name']").val("");
            form.find("[name='occasion']").val("");
            form.find("[name='day']").val("");
            form.find("[name='month']").val("");
            form.find("[name='christmas']").prop("checked", false);
            form.find("[name='fathersDay']").prop("checked", false);
            form.find("[name='mothersDay']").prop("checked", false);
            form.find("[name='valentinesDay']").prop("checked", false);

            localStorage.setItem("reminders", JSON.stringify(reminders));

            if (step < 3) {
              // @ts-ignore
              window.bloomableReminders.nextStep();
            } else {
              $("#bloomable-reminders-wizard-popup").hide();
              // @ts-ignore
              window.bloomableReminders.showGuestUserComplete();
            }
          }
        }
      },
      /**
       * @param {() => void} openCreateReminderFunction
       */
      showReturnPopup: function (openCreateReminderFunction) {
        const popup = $("#bloomable-reminders-return-popup");
        popup.show();

        popup.on("click", 'button[data-open="true"]', function (e) {
          e.preventDefault();
          e.stopPropagation();

          popup.hide();

          openCreateReminderFunction();
        });

        popup.on("click", 'a[href="#back"]', function (e) {
          e.preventDefault();
          e.stopPropagation();
          popup.hide();
        });

        popup.on("click", 'button[type="reset"]', function (e) {
          e.preventDefault();
          e.stopPropagation();
          popup.hide();
        });

        popup.on("click", "#bloomable-reminders-start-close-button", function (e) {
          e.preventDefault();
          e.stopPropagation();
          popup.hide();
        });
      },
      /**
       * @param {() => void} openCreateReminderFunction
       */
      showStartPopup: function (openCreateReminderFunction) {
        const popup = $("#bloomable-reminders-start-popup");

        console.info("showStartPopup", popup);

        popup.show();

        popup.on("click", 'button[data-open="true"]', function (e) {
          e.preventDefault();
          e.stopPropagation();

          popup.hide();

          openCreateReminderFunction();
        });

        popup.on("click", 'a[href="#back"]', function (e) {
          e.preventDefault();
          e.stopPropagation();
          popup.hide();
        });

        popup.on("click", 'button[type="reset"]', function (e) {
          e.preventDefault();
          e.stopPropagation();
          popup.hide();
        });

        popup.on("click", "#bloomable-reminders-start-close-button", function (e) {
          e.preventDefault();
          e.stopPropagation();
          popup.hide();
        });
      },
      /**
       * @param {boolean} loggedInUser
       */
      showReminderWizard: function (loggedInUser) {
        const popup = $("#bloomable-reminders-wizard-popup");
        popup.show();

        popup.on("click", 'a[href="#back"]', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var form = popup.find("form");

          form.find("[name='name']").val("");
          form.find("[name='occasion']").val("");
          form.find("[name='day']").val("");
          form.find("[name='month']").val("");
          form.find("[name='christmas']").prop("checked", false);
          form.find("[name='fathersDay']").prop("checked", false);
          form.find("[name='mothersDay']").prop("checked", false);
          form.find("[name='valentinesDay']").prop("checked", false);
          popup.hide();

          if (!loggedInUser) {
            // @ts-ignore
            window.bloomableReminders.resetSteps();
          }
        });

        popup.on("click", 'button[type="reset"]', function () {
          var form = popup.find("form");

          form.find("[name='name']").val("");
          form.find("[name='occasion']").val("");
          form.find("[name='day']").val("");
          form.find("[name='month']").val("");
          form.find("[name='christmas']").prop("checked", false);
          form.find("[name='fathersDay']").prop("checked", false);
          form.find("[name='mothersDay']").prop("checked", false);
          form.find("[name='valentinesDay']").prop("checked", false);
          popup.hide();

          if (!loggedInUser) {
            // @ts-ignore
            window.bloomableReminders.resetSteps();
          }
        });

        popup.on("click", "#bloomable-reminders-wizard-close-button", function () {
          var form = popup.find("form");

          form.find("[name='name']").val("");
          form.find("[name='occasion']").val("");
          form.find("[name='day']").val("");
          form.find("[name='month']").val("");
          form.find("[name='christmas']").prop("checked", false);
          form.find("[name='fathersDay']").prop("checked", false);
          form.find("[name='mothersDay']").prop("checked", false);
          form.find("[name='valentinesDay']").prop("checked", false);
          popup.hide();

          if (!loggedInUser) {
            // @ts-ignore
            window.bloomableReminders.resetSteps();
          }
        });

        if (!loggedInUser) {
          /**
           * @type {Array} reminders
           */
          let reminders = JSON.parse(localStorage.getItem("reminders") ?? "[]");

          for (let i = 0; i < reminders.length; i++) {
            if (step < 4) {
              // @ts-ignore
              window.bloomableReminders.nextStep();
            } else {
              popup.hide();
              // @ts-ignore
              window.bloomableReminders.showGuestUserComplete();
            }
          }
        }

        popup.find("form").on("submit", function (e) {
          e.preventDefault();

          // @ts-ignore
          window.bloomableReminders.saveWizardReminder($(this), loggedInUser);

          return false;
        });
      },
      complete: function () {
        const popup = $("#bloomable-reminders-complete-popup").show();

        popup.on("click", "#bloomable-reminders-complete-close-button", function (e) {
          e.preventDefault();
          e.stopPropagation();

          popup.hide();
        });

        popup.on("click", "span#bloomable-reminders-copy-code", function () {
          var copyText = document.getElementById("bloomable-reminders-code");
          if (copyText && copyText.textContent) {
            navigator.clipboard.writeText(copyText.textContent);
          }
        });

        popup.on("click", 'a[href="#back"]', function (e) {
          e.preventDefault();
          e.stopPropagation();

          popup.hide();
        });
        popup.on("click", 'button[type="reset"]', function (e) {
          e.preventDefault();
          e.stopPropagation();

          popup.hide();
        });
      },
      resetSteps: function () {
        const steps = $(".reminders-progress");

        const currentSelector = "div:nth-child(" + step + ")";

        const currentElement = steps.find(currentSelector);
        currentElement.removeClass("current");

        step = 1;

        const nextElement = steps.find("div:nth-child(" + step + ")");
        nextElement.addClass("current");

        localStorage.removeItem("reminders");
      },
      showGuestUserComplete: function () {
        const popup = $("#bloomable-reminders-guest-complete-popup");

        popup.on("click", "#bloomable-reminders-guest-complete-close-button", function (e) {
          e.preventDefault();
          e.stopPropagation();

          popup.hide();
        });

        popup.on("click", 'a[href="#back"]', function (e) {
          e.preventDefault();
          e.stopPropagation();

          popup.hide();
        });
        popup.on("click", 'button[type="reset"]', function (e) {
          e.preventDefault();
          e.stopPropagation();

          popup.hide();
        });

        popup.show();
      },
      nextStep: function () {
        const steps = $(".reminders-progress");

        const currentSelector = "div:nth-child(" + step + ")";

        const currentElement = steps.find(currentSelector);
        currentElement.removeClass("current");

        step += 1;

        const nextElement = steps.find("div:nth-child(" + step + ")");
        nextElement.addClass("current");
      },

      /**
       * @param {Event} e
       */
      showRemindersPopup: function (e) {
          console.info("showRemindersPopup");

          if (e) {
          console.info("e", e);
          e.preventDefault();
          e.stopPropagation();
        }

        if ($("#reminders-wizard-header,#reminders-new-header").length > 0) {
          console.info("reminder wizard");

          // @ts-ignore
          window.bloomableReminders.showStartPopup(function () {
            const dataCustomer = $("#reminders-wizard-header").data("customer");
            const count = $("#reminders-wizard-header").data("count");

            console.info('dataCustomer', dataCustomer);
            console.info('count', count);

            if (count > 0) {
              Array(count - 1)
                .fill(0)
                .forEach(function () {
                  // @ts-ignore
                  window.bloomableReminders.nextStep();
                });
            }

            const isCustomer = dataCustomer == "true" || dataCustomer == true;
            // @ts-ignore
            window.bloomableReminders.showReminderWizard(isCustomer);
          });
        }
      },
    };
  // @ts-ignore
  })(window.jQuery);

(
  /**
   * @param {JQueryStatic} $
   */
  function ($) {
    window.addEventListener("DOMContentLoaded", function () {
    // @ts-ignore
    window.bloomableReminders.syncLocalReminders();

    console.info("checking hash");

    $("#reminder-icon-wrapper").load("/apps/reminders/add", function () {
      const hash = window.location.hash;
      console.info("hash", hash);
      if (hash === "#reminders" || window.location.search.includes("showreminders")) {
        console.info("show reminders popup");

        // @ts-ignore
        window.bloomableReminders.showRemindersPopup(null);
      }

      $("ul.mobile-nav-menu a[href='/reminders'],a[data-reminders-link]").on("click", function (e) {
          console.info('info showing popup from nav link click');


          // @ts-ignore
        window.bloomableReminders.showRemindersPopup(e);
      });

      if ($("#reminders-new-header").length > 0) {
        $.get("/apps/reminders/next-reminders", function (data) {
          $("#bloomable-reminders-start-popup-marketing").html(data);
        });

        $("#reminders-new-header").on("click", function () {
          const dataCustomer = $(this).data("customer");
          const count = $(this).data("count");

          const isCustomer = dataCustomer == "true" || dataCustomer == true;

          if (isCustomer && count > 0) {
            // @ts-ignore
            window.bloomableReminders.showReturnPopup(function () {
              // @ts-ignore
              window.bloomableReminders.showNewReminder();
            });
          } else {
            // @ts-ignore
            window.bloomableReminders.showStartPopup(function () {
              // @ts-ignore
              window.bloomableReminders.showNewReminder();
            });
          }
        });
      }

      console.info("check button type");
      if ($("#reminders-wizard-header").length > 0) {
        console.info("has wizard header");

        $("#reminders-wizard-header").on("click", function () {
          const $this = this;
          console.info("button clicked", this);

          // @ts-ignore
          window.bloomableReminders.showStartPopup(function () {
            console.info('showStartPopup');

            const dataCustomer = $($this).data("customer");
            const count = $($this).data("count");

            console.info($this);

            console.info('dataCustomer', dataCustomer);
            console.info('count', count);

            if (count > 0) {
              Array(count - 1)
                .fill(0)
                .forEach(function () {
                  // @ts-ignore
                  window.bloomableReminders.nextStep();
                });
            }

            const isCustomer = dataCustomer == "true" || dataCustomer == true;
            // @ts-ignore
            window.bloomableReminders.showReminderWizard(isCustomer);
          });
        });
      }
    });
  });
// @ts-ignore
})(window.jQuery);
